import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getMe, clearAuthToken, User } from "../api/auth";

export function useAuth() {
    const queryClient = useQueryClient();

    const { data: user, isLoading, error, isError } = useQuery<User | null>({
        queryKey: ["auth", "user"],
        queryFn: getMe,
        retry: false,
        staleTime: 0, // Always fetch latest user data to ensure we have full profile details
    });

    const logout = () => {
        // Preserve language preference
        const language = localStorage.getItem('i18nextLng');

        clearAuthToken();
        localStorage.clear();

        // Restore language preference
        if (language) {
            localStorage.setItem('i18nextLng', language);
        }

        queryClient.setQueryData(["auth", "user"], null);
        window.location.href = "/auth/login";
    };

    return {
        user,
        isLoading,
        error: isError ? error : null,
        isAuthenticated: !!user && !!user.id, // Check if user exists and has ID
        logout,
    };
}
